module.exports = __webpack_public_path__ + "img/BV.10bfd459.svg";